import React from "react";


export const FreshchatWebWidgetInitialize = (props, callback) => {
    console.log("Freschat Interface initialized for web")
    let checkedInGuestInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"));
    let room = localStorage.getItem("room")

    if (!window.device) {

        if (window.fcWidget) {
            console.log("Freshchat Interface initialized for web - successfull")

            callback(true);
            props.setChatWidgetInnitialized(true);

            let config;

            if (room && room != "null") {
                config = {
                    headerProperty: {
                        hideChatButton: true,
                        appName: props.freshChatData.login.businessName || null,
                        appLogo: props.freshChatData.login.businessIconUrl || null,
                        backgroundColor: props.menuColor.assetBackgroundSelectorColor || null,
                    },
                    externalId: checkedInGuestInfo[0].reservationNumber.toString(),
                    // restoreId: { this key is to restore user from in browser ( or if user tried to logout and login again ) , we need to save this in our database for futureRef}
                };


                if (checkedInGuestInfo[0]) {
                    window.fcWidget.user.get()
                        .then((res) => {

                            if(res.data){
                                if(!res.data.identifier) window.fcWidget.setExternalId(checkedInGuestInfo[0].reservationNumber.toString())
                            }

                            window.fcWidget.user.update({
                                firstName: checkedInGuestInfo[0].guestProfile.firstName,
                                lastName: checkedInGuestInfo[0].guestProfile.lastName,
                                email: checkedInGuestInfo[0].guestProfile.email,
                                phone: checkedInGuestInfo[0].guestProfile.phone,
                                meta: {
                                    "cf_room": room,
                                }
                            })
                        })
                        .catch((err) => {
                            window.fcWidget.user.create({
                                firstName: checkedInGuestInfo[0].guestProfile.firstName || null,
                                lastName: checkedInGuestInfo[0].guestProfile.lastName || null,
                                email: checkedInGuestInfo[0].guestProfile.email || null,
                                phone: checkedInGuestInfo[0].guestProfile.phone || null,
                                externalId: checkedInGuestInfo[0].reservationNumber.toString(),
                                meta: {
                                    "cf_room": room,
                                }
                            })
                        })
                }


            } else {
                config = {
                    headerProperty: {
                        hideChatButton: true,
                        appName: props.freshChatData.logout.businessName || null,
                        appLogo: props.freshChatData.logout.businessIconUrl || null,
                        backgroundColor: props.menuColor.assetBackgroundSelectorColor || null,
                    }
                };

                window.fcWidget.user.get()
                    .then((res) => {
                        if (res.status == 200) {
                            window.fcWidget.user.clear();
                        }
                    })
            }


            window.fcWidget.setConfig(config);
            sessionStorage.setItem("FreshchatInit", true)
        } else {
            callback(true);
            console.log("Freshchat src should in env to init")
            console.log(process.env.REACT_APP_FRESHCHAT_WEB_CONFIG)
            // to Init Freshchat, go to: Admin Setting > Web > Embed Code in freshchat dasboard and paste the src in `REACT_APP_FRESHCHAT_WEB_CONFIG` variable
        }

    } else {
        console.log("Error Init Freshchat")
    }

}

export const FreshchatWebWidgetShowConversation = () => {
    console.log("Freshchat show conversation called for web")
    if (sessionStorage.getItem("FreshchatInit")) {
        window.fcWidget.open();

        window.fcWidget.user.get()
            .then((res) => {
                console.log(res)
            })
            .catch(err => console.log(err))
    }
}